import axios from '@/plugins/axios'

const state = {
    tenantCode: '',
    token: '',
    user: {},
    lastTenantCode: '',
    lastUsername: '',
}

const getters = {
    tenantCode: state => state.tenantCode,
    token: state => state.token,
    user: state => state.user,
    lastTenantCode: state => state.lastTenantCode,
    lastUsername: state => state.lastUsername,
}

const actions = {
    async login({ commit }, user) {
        let login = {
            tenant_code: user.tenantCode,
            email: user.email,
            password: user.password,
        }

        return new Promise((resolve, reject) => {
            axios
                .post('/auth/login', login)
                .then(res => {
                    const data = {
                        token: res.data.token,
                        user: res.data.user,
                        tenantCode: res.data.tenant_code,
                        lastTenantCode: res.data.tenant_code,
                        lastUsername: res.data.user.email,
                    }

                    commit('makeAuth', data)

                    resolve(res)
                })
                .catch(err => {
                    // Tratamento específico para reseller bloqueado por inadimplência
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.error ===
                            'reseller_blocked_for_defaulting'
                    ) {
                        err.response.data.isDefaultingBlock = true
                        err.response.data.redirectTo =
                            err.response.data.redirect_to
                    }
                    reject(err)
                })
        })
    },

    setTenantCode({ commit }, tenantCode) {
        commit('setTenantCode', tenantCode)
    },

    logout({ commit }) {
        return new Promise(resolve => {
            axios.post('/auth/logout').then(() => {
                commit('makeLogout')

                resolve()
            })
        })
    },

    syncUser({ commit }) {
        return new Promise(resolve => {
            axios.get('/auth/me').then(res => {
                if (typeof res != 'undefined') {
                    commit('setUser', res.data.user)
                }

                resolve()
            })
        })
    },

    clear({ commit }) {
        commit('makeLogout')
    },
}

const mutations = {
    makeAuth(state, data) {
        state.token = data.token
        state.user = data.user
        state.tenantCode = data.tenantCode
        state.lastTenantCode = data.lastTenantCode
        state.lastUsername = data.lastUsername
    },

    setTenantCode(state, tenantCode) {
        state.tenantCode = tenantCode
    },

    makeLogout(state) {
        state.token = ''
        state.user = {}
        state.tenantCode = ''
    },

    setUser(state, user) {
        state.user = user
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
